import { ICycleConfiguration } from 'typings/cycleConfiguration';
import { ICycleBudgetField } from 'typings/cycleBudgetField';
import { ICycleBudget } from 'typings/cycleBudget';
import { AmountCode } from 'typings/enums';

export const LabAmountCodes = new Set<AmountCode>([
    AmountCode.Merit,
    AmountCode.Bonus,
    AmountCode.VariablePay,
    AmountCode.Stock
]);

export class ConfigurationUtils {

    bindFieldsToBudgets(cycleConfiguration: ICycleConfiguration): void {
        if (!cycleConfiguration.budgets) {
            return;
        }
        cycleConfiguration.budgets.forEach(budget => {
            this.clearFields(false, budget);
            this.bindFields(cycleConfiguration.budgetFields, budget, budget.budgetCycleId);
            this.updateColor(budget);
            if (!this.getHasAnyLabAmount(budget)) {
                this.setAutoSyncWithLab(false, budget);
            }
        });
    }

    bindFields(budgetFields: ICycleBudgetField[], budget: ICycleBudget, budgetCycleId: number): void {
        budgetFields.forEach(budgetField => {
            if (budgetField.budgetCycleId === budgetCycleId) {
                budget.cycleBudgetFields.push(budgetField);
            }
        });

        budget.associatedFields =
            budget.cycleBudgetFields.map(budgetField => budgetField.title) as string[];
    }

    clearFields(clearBudgetCycleId: boolean = false, budget: ICycleBudget): void {
        if (clearBudgetCycleId) {
            budget.cycleBudgetFields.forEach((budgetField) => this.setBudgetCycleId(null, budgetField));
        }
        budget.cycleBudgetFields = [];
    }

    setBudgetCycleId(budgetCycleId: Nullable<number>, budgetField: ICycleBudgetField): void {
        budgetField.budgetCycleId = budgetCycleId;
    }

    updateColor(budget: ICycleBudget): void {
        const topPriorityField = this.getTopPriorityField(budget);
        if (!topPriorityField) {
            return;
        }

        budget.color = topPriorityField.color;
    }

    getTopPriorityField(budget: ICycleBudget): Nullable<ICycleBudgetField> {
        let topPriority: number;
        let topPriorityField: Nullable<ICycleBudgetField> = null;
        budget.cycleBudgetFields.forEach(budgetField => {
            if (!topPriority || budgetField.colorPriority < topPriority) {
                topPriority = budgetField.colorPriority;
                topPriorityField = budgetField;
            }
        });

        return topPriorityField ? topPriorityField : null;
    }

    getHasAnyLabAmount(budget: ICycleBudget): boolean {
        return budget.cycleBudgetFields.find(budgetField =>
            LabAmountCodes.has(budgetField.amountCode)) !== undefined;
    }

    setAutoSyncWithLab(value: boolean, budget: ICycleBudget): void {
        budget.autoSync = value;
    }

    bindAmountsToBudget(budget: ICycleBudget, budgetFields: ICycleBudgetField[]): void {
        this.clearFields(false, budget);
        this.bindFields(budgetFields, budget, budget.budgetCycleId);
    }
}